import React from 'react';
import { IIconProps } from './utils';

type InitialsProps = IIconProps & {
  initialsText?: string;
};

export const Initials = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  initialsText,
  ...rest
}: InitialsProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle cx="15" cy="15" fill={fill} r="15" />
    <text
      dominantBaseline="middle"
      fill="white"
      fontFamily="sans-serif"
      style={{ height: '100%', width: '100%' }}
      textAnchor="middle"
      x="50%"
      y="55%"
    >
      {initialsText}
    </text>
  </svg>
);
